
import ArticleCard from '~/components/global/ArticleCard'
export default {
  name: 'Articles',
  components: { ArticleCard },
  props: {
    title: {
      type: String,
      require: true,
    },
    description: {
      type: String,
      require: true,
    },
    articles: {
      type: Array,
      require: true,
    },
  },
}
